import { useContext, useEffect, useState } from 'react';

import { Devices } from '../../service/Devices';
import { DropdownMenuContext } from '../jdsdropdownmenu/context';
import { JDSDropdownMenuSubMenuProps } from './generated/interface';
import { handlePrevOrNextItemFocus } from '../jdsdropdownmenu/utils/dropdownmenu-logic';
import { useRootRef } from '../../hooks/useRootRef';

const DROPDOWNMENUSUBMENU_SELECTOR =
  'div.j-JDSDropdownMenuSubMenuInternal-menu-container';
export const withLogic =
  (
    Component: React.ComponentType<JDSDropdownMenuSubMenuProps>
  ): React.FC<JDSDropdownMenuSubMenuProps> =>
  (props: JDSDropdownMenuSubMenuProps) => {
    const { element, rootRef } = useRootRef();
    const context = useContext(DropdownMenuContext);
    const [visible, setVisible] = useState(false);

    const dropdownMenuSubMenuRef = element?.querySelector<HTMLDivElement>(
      DROPDOWNMENUSUBMENU_SELECTOR
    );

    useEffect(() => {
      const handleKeyDown = (event: KeyboardEvent) => {
        const isOpen = dropdownMenuSubMenuRef?.contains(document.activeElement);
        if (isOpen) {
          switch (event.key) {
            case 'ArrowUp': {
              handlePrevOrNextItemFocus(
                -1,
                dropdownMenuSubMenuRef,
                '.j-JDSDropdownMenuItem-container'
              );
              event.preventDefault();
              event.stopPropagation();
              break;
            }
            case 'ArrowDown': {
              handlePrevOrNextItemFocus(
                1,
                dropdownMenuSubMenuRef,
                '.j-JDSDropdownMenuItem-container'
              );
              event.preventDefault();
              event.stopPropagation();
              break;
            }
          }
        }
      };

      if (context.activeMenuId) {
        window.addEventListener('keydown', handleKeyDown);
      }

      return () => {
        window.removeEventListener('keydown', handleKeyDown);
      };
    }, [context.activeMenuId, dropdownMenuSubMenuRef]);

    useEffect(() => {
      setTimeout(() => {
        setVisible(true);
      }, 50);
    }, []);

    const isMobile = Devices.isMobile();

    return (
      <Component
        {...{
          ...props,
          rootRef,
          _menuContainerVisible: visible,
          _menuWidth: 'max-content',
          offsetX: isMobile ? 0 : props.offsetX,
          offsetY: isMobile ? 0 : props.offsetY,
          _platform: isMobile ? 'mobile' : 'desktop',
          children: props?.children?.[0].props._childrenProps.props.children
        }}
      />
    );
  };
